/* eslint-disable react/no-array-index-key */
import { ListLoadingProps } from './types';

import * as S from './styles';

const DefaultStyle = ({ length = 5 }) => {
  return (
    <S.LoadingWrapper data-testid="defaultLoading">
      {Array.from({ length }).map((_, i) => (
        <S.Line key={i} />
      ))}
    </S.LoadingWrapper>
  );
};

const LinesLoadingSmall = ({ length = 10 }) => {
  return (
    <S.LoadingWrapper data-testid="linesSmallLoading">
      {Array.from({ length }).map((_, i) => (
        <S.LineSmallContainer key={i}>
          <S.LineSmall />
        </S.LineSmallContainer>
      ))}
    </S.LoadingWrapper>
  );
};

const LinesLoadingMedium = ({ length = 10 }) => {
  return (
    <S.LoadingWrapper data-testid="linesSmallLoading">
      {Array.from({ length }).map((_, i) => (
        <S.LineMediumContainer key={i}>
          <S.LineSmall />
        </S.LineMediumContainer>
      ))}
    </S.LoadingWrapper>
  );
};

const ListLoading: React.FC<ListLoadingProps> = ({
  loadingStyle = 'Default',
  linesLength,
}) => {
  return (
    <S.Container data-testid="listLoading">
      {loadingStyle === 'Default' && <DefaultStyle />}
      {loadingStyle === 'LinesSmall' && (
        <LinesLoadingSmall length={linesLength} />
      )}
      {loadingStyle === 'LinesMedium' && (
        <LinesLoadingMedium length={linesLength} />
      )}
    </S.Container>
  );
};

export default ListLoading;
